module.exports = "https://s91588.cdn.ngenix.net/news-frontend/_next/static/images/head-9274410ef84436e63d5ea033500b3243.png";